import React from 'react';
import { Col, Row } from 'antd';

import {
  HeaderGroupElement,
  GroupElementWrapper as ProductDisplayWrapper,
} from 'pages/product-full-view/shared/components';

import { ProductOverlayPropertyItem } from './ProductOverlayPropertyItem';

import { checkInvalidDataInGroupProperties } from '../utils';
import { useGetProductOverlayInfo } from './overlayHooks';

export const DisplayProductOverlayInfo = (props) => {
  const {
    moduleProduct,
    productEnums,
    dataProductOverlayModule = {},
    dataOriginalProductModule = {},
  } = props;

  const {
    filteredModuleProduct: { isGroup, moduleProperties, moduleGroupProperties },
    isEmptyData,
    originalFormattedData,
    overlayFormattedData,
  } = useGetProductOverlayInfo({
    dataOriginalProductModule,
    dataProductOverlayModule,
    moduleProduct,
  });

  if (isEmptyData) return null;

  if (isGroup) {
    return (
      <Row
        style={{
          position: 'relative',
          marginLeft: 6,
        }}
      >
        <Col span={24}>
          {moduleGroupProperties.map((groupItem) => {
            const invalidData = checkInvalidDataInGroupProperties(
              overlayFormattedData,
              groupItem.groupProperties
            );

            if (invalidData || groupItem?.groupProperties?.length === 0) {
              return null;
            }

            return (
              <Row
                key={groupItem.nameGroup}
                className='product-detail__property-container'
              >
                <ProductDisplayWrapper
                  span={24}
                  style={{
                    width: '100%',
                    marginTop: 12,
                  }}
                >
                  <HeaderGroupElement
                    header={groupItem.nameGroup}
                    style={{ marginTop: 8 }}
                  />
                  <Col span={24} style={{ paddingBottom: 12 }}>
                    {groupItem.groupProperties.map((property) => (
                      <ProductOverlayPropertyItem
                        key={property.propertyName}
                        property={property}
                        dataProductOverlay={overlayFormattedData}
                        dataOriginalProduct={originalFormattedData}
                        productEnums={productEnums}
                      />
                    ))}
                  </Col>
                </ProductDisplayWrapper>
              </Row>
            );
          })}
        </Col>
      </Row>
    );
  }

  return (
    <Row
      style={{
        position: 'relative',
        marginLeft: 6,
      }}
    >
      <Row className='product-detail__property-container'>
        <Col span={24} style={{ marginLeft: 12 }}>
          {moduleProperties.map((property) => (
            <ProductOverlayPropertyItem
              key={property.propertyName}
              property={property}
              dataProductOverlay={overlayFormattedData}
              dataOriginalProduct={originalFormattedData}
              productEnums={productEnums}
            />
          ))}
        </Col>
      </Row>
    </Row>
  );
};
